module.exports = Em.Mixin.create
  getModelName: ->
    @constructor.toString().split('.')[1].underscore()
      .split('_')[...-1].join('_')

  mediator: Em.inject.service('mediator')

  recordChanged: (type, model) ->
    @get('mediator').trigger('modelChanged', type, @getModelName(), model)

  createRecord: (store, type, snapshot) ->
    promise = @_super(arguments...)
    promise.then => @recordChanged('create', snapshot)
    promise

  updateRecord: (store, type, snapshot) ->
    promise = @_super(arguments...)
    promise.then => @recordChanged('update', snapshot)
    promise

  deleteRecord: (store, type, snapshot) ->
    promise = @_super(arguments...)
    promise.then => @recordChanged('destroy', snapshot)
    promise


